import React, { useState, useRef } from 'react';
import { Select, Icon, Dropdown, Tooltip, Modal, CheckBox, Button } from '../../components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function SegmentationDropDownRow({
  segmentations = [],
  activeSegmentation,
  onActiveSegmentationChange,
  disableEditing,
  onToggleSegmentationVisibility,
  onSegmentationEdit,
  onSegmentationDownload,
  onSegmentationDownloadRTSS,
  onSegmentationSendAPI,
  storeSegmentation,
  onSegmentationDelete,
  onSegmentationAdd,
  addSegmentationClassName,
}) {
  const handleChange = option => {
    onActiveSegmentationChange(option.value); // Notify the parent
  };

  const selectOptions = segmentations.map(s => ({
    value: s.id,
    label: s.label,
  }));
  const { t } = useTranslation('SegmentationTable');

  const [showSettings, setShowSettings] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState({
    retrainModel: 0,
    downloadMesh: 0,
  });
  const buttonRef = useRef(null);

  const handleSendClick = () => {
    setShowSettings(true);
  };

  const handleCheckboxChange = checkboxName => {
    setCheckboxStates(prevState => ({
      ...prevState,
      [checkboxName]: prevState[checkboxName] === 0 ? 1 : 0,
    }));
  };

  const handleSendConfirm = () => {
    onSegmentationSendAPI(activeSegmentation.id, checkboxStates);
    setShowSettings(false);
  };

  const handleClose = () => {
    setShowSettings(false);
  };

  if (!activeSegmentation) {
    return null;
  }

  return (
    <>
      <div className="group mx-0.5 mt-[8px] flex items-center bg-white pb-[10px]">

        {/* TODO: Delete More Option next to the segmentation title in Segmentations */}
        {/* <div
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Dropdown
            id="segmentation-dropdown"
            showDropdownIcon={false}
            alignment="left"
            itemsClassName={`text-primary-active ${addSegmentationClassName}`}
            showBorders={false}
            maxCharactersPerLine={30}
            list={[
              ...(!disableEditing
                ? [
                    {
                      title: t('Add new segmentation'),
                      onClick: () => {
                        onSegmentationAdd();
                      },
                    },
                  ]
                : []),
              ...(!disableEditing
                ? [
                    {
                      title: t('Rename'),
                      onClick: () => {
                        onSegmentationEdit(activeSegmentation.id);
                      },
                    },
                  ]
                : []),
              {
                title: t('Delete'),
                onClick: () => {
                  onSegmentationDelete(activeSegmentation.id);
                },
              },
              ...(!disableEditing
                ? [
                    {
                      title: t('Export DICOM SEG'),
                      onClick: () => {
                        storeSegmentation(activeSegmentation.id);
                      },
                    },
                  ]
                : []),
              ...[
                {
                  title: t('Download DICOM SEG'),
                  onClick: () => {
                    onSegmentationDownload(activeSegmentation.id);
                  },
                },
                {
                  title: t('Download DICOM RTSTRUCT'),
                  onClick: () => {
                    onSegmentationDownloadRTSS(activeSegmentation.id);
                  },
                },
              ],
            ]}
          >
            <div className="hover:bg-gray-200 grid h-[28px] w-[28px]  cursor-pointer place-items-center rounded-[4px]">
              <Icon name="icon-more-menu"></Icon>
            </div>
          </Dropdown>
    </div> */}
        {selectOptions?.length && (
          <Select
            id="segmentation-select"
            isClearable={false}
            onChange={handleChange}
            components={{
              DropdownIndicator: () => (
                <Icon
                  name={'chevron-down-new'}
                  className="mr-2"
                />
              ),
            }}
            isSearchable={false}
            options={selectOptions}
            value={selectOptions?.find(o => o.value === activeSegmentation.id)}
            className="text-aqua-pale h-[26px] w-1/2 text-[13px]"
          />
        )}
        <div className="flex items-center">
          {/* <Tooltip
            position="bottom-right"
            content={
              <div className="flex flex-col">
                <div className="text-[13px] text-black">Series:</div>
                <div className="text-black text-[13px]">{activeSegmentation.description}</div>
              </div>
            }
          >
            <Icon
              name="info-action"
              className="text-primary-active"
            />
          </Tooltip> */}
          <div
            className="mr-1 grid h-[28px] w-[28px]  cursor-pointer place-items-center rounded-[4px] hover:bg-gray-200"
            onClick={() => onToggleSegmentationVisibility(activeSegmentation.id)}
          >
            {activeSegmentation.isVisible ? (
              <Icon
                name="row-shown"
                className="text-primary-active"
              />
            ) : (
              <Icon
                name="row-hidden"
                className="text-primary-active"
              />
            )}
          </div>
        </div>
        {/* Send Segmentation Items*/}
        <Modal
          isOpen={showSettings}
          onClose={handleClose}
          title="Export Segmentation Options"
        >
          <div className="p-4">
            <CheckBox
              checked={checkboxStates.retrainModel === 1}
              onChange={() => handleCheckboxChange('retrainModel')}
              label="Set Segmentation as Training Data"
            />
            <CheckBox
              checked={checkboxStates.retrainModel === 1}
              onChange={() => handleCheckboxChange('downloadMesh')}
              label="Prepare study for planning VIDAA process (Generate meshes from Segmentation)"
            />
            <div className="mt-4 flex justify-end">
              <Button
                onClick={handleClose}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button onClick={handleSendConfirm}>Send</Button>
            </div>
          </div>
        </Modal>
      </div>

      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '10px',
          backgroundColor: 'white',
        }}
        onClick={handleSendClick}
      >
        <div className="text-primary-active group-hover:bg-secondary-dark mr-[25px] flex items-center rounded-[4px] group-hover:cursor-pointer">
          <Button className="text-[13px]">Send Segmentation</Button>
        </div>
      </div> */}
    </>
  );
}

SegmentationDropDownRow.propTypes = {
  segmentations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeSegmentation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
  }),
  onActiveSegmentationChange: PropTypes.func.isRequired,
  disableEditing: PropTypes.bool,
  onToggleSegmentationVisibility: PropTypes.func,
  onSegmentationEdit: PropTypes.func,
  onSegmentationDownload: PropTypes.func,
  onSegmentationDownloadRTSS: PropTypes.func,
  storeSegmentation: PropTypes.func,
  onSegmentationDelete: PropTypes.func,
  onSegmentationAdd: PropTypes.func,
};

SegmentationDropDownRow.defaultProps = {
  segmentations: [],
  disableEditing: false,
};

export default SegmentationDropDownRow;
